import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    NO_CHANGE,
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {
    setTimeSlotsAction
} from '../../../../../../_local/one-state-timeslots-athena/src/actions';
import { format } from 'one-util-date';

export const enum Types {
    GETALLTIMESLOTS_FETCH = "get-all-timeslots-fetch/athena",
}

/**
 * This function will fetch all time slots
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchGetAllTimeSlotsAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, settings: {
            athenaendpoints: {
                gettimeslots
            },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.GETALLTIMESLOTS_FETCH),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                const callGetAllTimeSlotsAPI = () => {
                    const { date, providerID, departmentID, visitTypeID, endDate } = action.payload || {};
                    
                    console.log('Timeslots API - Received payload:', {
                        date,
                        providerID,
                        departmentID,
                        visitTypeID,
                        endDate,
                        rawPayload: action.payload
                    });
                    
                    // Format date as MM/DD/YYYY
                    const formatDate = (dateStr: string) => {
                        if (!dateStr) {
                            console.error('formatDate called with empty dateStr');
                            return '';
                        }
                        try {
                            const date = new Date(dateStr);
                            const month = String(date.getMonth() + 1).padStart(2, '0');
                            const day = String(date.getDate()).padStart(2, '0');
                            const year = date.getFullYear();
                            return `${month}/${day}/${year}`;
                        } catch (e) {
                            console.error('Error formatting date:', e);
                            return '';
                        }
                    };
                    
                    const startDate = formatDate(date);
                    const formattedEndDate = endDate ? formatDate(endDate) : '';
                    
                    // Prepare POST payload - use camelCase field names as expected by API
                    const payload: any = {
                        providerID: providerID ? String(providerID) : '',
                        departmentID: departmentID ? String(departmentID) : '',
                        startDate: startDate,
                        endDate:startDate
                    };
                    
                    // if (formattedEndDate) {
                    //     payload.endDate = formattedEndDate;
                    // }
                    
                    console.log('Timeslots API - Final payload being sent:', payload);
                    console.log('Payload types:', {
                        providerID_type: typeof payload.providerID,
                        departmentID_type: typeof payload.departmentID,
                        startDate_type: typeof payload.startDate
                    });
                    
                    let headers = new Headers();
                    headers.append('Content-Type', 'application/json');
                    
                    console.log('Timeslots API - About to call server.post with payload:', JSON.stringify(payload));
                    
                    const responsefromAPI = server.post({
                        headers: headers,
                        path: gettimeslots,
                        data: payload
                    })
                        .then((responsegetalltimeslots: any) => responsegetalltimeslots)
                        .catch((getalltimeslotsres: any) => {
                            log.error(
                                "ccw-gadget,getalltimeslots-athena",
                                "getalltimeslots-athena", {
                                    getalltimeslotsres
                                }
                            );
                            let errorbuild: ErrorObject = {
                                source: "GetAllTimeSlots",
                                type: "error",
                                status: getalltimeslotsres?.status,
                                erroritems: getalltimeslotsres?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return errorbuild;
                        })
                    log.debug(
                        "ccw-gadget,getalltimeslots-athena",
                        "getalltimeslots-athena request and response", {
                            payload,
                            responsefromAPI
                        });
                    return from(responsefromAPI)
                }
                //Calling callGetAllTimeSlotsAPI function here
                //the reason is we need to use pipe function.
                return callGetAllTimeSlotsAPI().
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions: any = [];
                            if (responseAfterTransform.error) {
                                actions.push(addAction(responseAfterTransform.error));
                            } else {
                                log.debug(
                                    "ccw-gadget,getalltimeslots-athena",
                                    "Dispatching time slots to store", {
                                        timeslots: responseAfterTransform.timeslots,
                                        count: responseAfterTransform.timeslots?.length
                                    });
                                actions.push(setTimeSlotsAction(responseAfterTransform.timeslots));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
